var _g, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminLaunchSettins(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_101_1145)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.356,
    r: 20,
    fill: "url(#paint0_linear_101_1145)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.356,
    r: 20,
    fill: "url(#paint1_linear_101_1145)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.356,
    r: 17.5,
    stroke: "url(#paint2_linear_101_1145)",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.8438,
    cy: 20.356,
    r: 17.5,
    stroke: "url(#paint3_linear_101_1145)",
    strokeWidth: 5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8356 30.1744C22.7415 30.1744 22.6474 30.1532 22.5607 30.1098L14.1834 25.9175C13.9756 25.8136 13.8447 25.6009 13.8447 25.3685V15.3418C13.8447 15.1095 13.9756 14.8968 14.1843 14.7929L22.5681 10.603C22.7407 10.5171 22.9436 10.5171 23.1162 10.603L31.5041 14.7929C31.7127 14.8968 31.8436 15.1095 31.8436 15.3418V25.3636C31.8436 25.596 31.7127 25.8087 31.5041 25.9126L23.1097 30.1098C23.0238 30.1532 22.9297 30.1744 22.8356 30.1744ZM15.072 24.9897L22.8356 28.8744L30.6164 24.984V15.7215L22.8421 11.8384L15.072 15.7215V24.9897Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2296 25.977C31.1224 25.977 31.0144 25.9491 30.9154 25.8902L26.9146 23.5012C26.6241 23.3277 26.5284 22.9505 26.7026 22.6601C26.8753 22.3696 27.2516 22.2731 27.5437 22.4482L31.5446 24.8372C31.835 25.0107 31.9308 25.3879 31.7565 25.6783C31.6428 25.8706 31.439 25.977 31.2296 25.977ZM18.458 18.3434C18.3508 18.3434 18.2428 18.3156 18.1438 18.2567L14.1429 15.8676C13.8525 15.6942 13.7576 15.317 13.931 15.0257C14.1037 14.7353 14.4792 14.6388 14.7721 14.8138L18.7729 17.2029C19.0642 17.3763 19.1591 17.7535 18.9849 18.0448C18.8711 18.2371 18.6674 18.3434 18.458 18.3434ZM14.4587 25.9851C14.2493 25.9851 14.0456 25.8788 13.931 25.6865C13.7567 25.396 13.8517 25.0189 14.1429 24.8454L18.1438 22.4564C18.4375 22.2821 18.8122 22.3778 18.9849 22.6683C19.1591 22.9587 19.0642 23.3359 18.7729 23.5093L14.7721 25.8984C14.6739 25.9573 14.5659 25.9851 14.4587 25.9851ZM27.2304 18.3434C27.0209 18.3434 26.8172 18.2371 26.7026 18.0448C26.5284 17.7543 26.6233 17.3772 26.9146 17.2037L30.9154 14.8147C31.2083 14.6404 31.5838 14.7353 31.7565 15.0266C31.9308 15.317 31.8358 15.6942 31.5446 15.8676L27.5437 18.2567C27.4455 18.3156 27.3375 18.3434 27.2304 18.3434ZM22.836 15.8644C22.4973 15.8644 22.2223 15.5895 22.2223 15.2507V11.1517C22.2223 10.813 22.4973 10.5381 22.836 10.5381C23.1747 10.5381 23.4496 10.813 23.4496 11.1517V15.2507C23.4496 15.5895 23.1747 15.8644 22.836 15.8644ZM22.836 30.1742C22.4973 30.1742 22.2223 29.8993 22.2223 29.5605V25.4697C22.2223 25.131 22.4973 24.8561 22.836 24.8561C23.1747 24.8561 23.4496 25.131 23.4496 25.4697V29.5605C23.4496 29.8993 23.1747 30.1742 22.836 30.1742Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8365 26.0833C22.7375 26.0833 22.6385 26.0596 22.5477 26.0113L18.1705 23.6796C17.9701 23.5724 17.8457 23.3646 17.8457 23.1379V17.5662C17.8457 17.3387 17.9709 17.1301 18.1722 17.0237L22.5305 14.7181C22.713 14.6126 22.9421 14.6003 23.1311 14.701L27.5157 17.0246C27.7161 17.1317 27.8413 17.3404 27.8413 17.567V23.1379C27.8413 23.3646 27.7161 23.5732 27.5157 23.6796L23.1229 26.0113C23.0337 26.0596 22.9355 26.0833 22.8365 26.0833ZM19.0738 22.7697L22.8382 24.7743L26.6165 22.7689V17.9352L22.8488 15.9388L19.0738 17.936V22.7697Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_101_1145",
    x: 0.847312,
    y: 0.355957,
    width: 43.9929,
    height: 43.9929,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.99644
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.998219
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_101_1145"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_101_1145",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.66667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.33333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_101_1145"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_101_1145",
    x1: 38.7548,
    y1: 34.5757,
    x2: 26.6622,
    y2: -0.315869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#011789"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590159,
    stopColor: "#1A23FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A2FFE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_101_1145",
    x1: 5.10198,
    y1: 38.0977,
    x2: 40.5855,
    y2: 2.61419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.21
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_101_1145",
    x1: 24.4598,
    y1: 40.356,
    x2: 42.8267,
    y2: 21.063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C95FF",
    stopOpacity: 0.66
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7C8FED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_101_1145",
    x1: 0.84375,
    y1: 3.2131,
    x2: 29.7595,
    y2: 47.3754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminLaunchSettins);
export default __webpack_public_path__ + "static/media/admin_launchSettins.999a04e661d4ad18ab52f1123069e599.svg";
export { ForwardRef as ReactComponent };